// extracted by mini-css-extract-plugin
export default {"user":"UserProfile_user__hp+XL","userActive":"UserProfile_userActive__oUUM1","menuItem":"UserProfile_menuItem__9wyMf"};